<template>
    <div class="home-page">
        <div class="banner"></div>
        <div class="content">
            <div class="row">
                <div :class="['col', isLogin ? 'col-12' : 'col-18']">
                    <notice-panel :height="324"></notice-panel>
                </div>
                <div class="col col-12" v-if="isLogin">
                    <center-service-panel :height="324"></center-service-panel>
                </div>
                <div class="col col-6" v-else>
                    <login-panel :height="324"></login-panel>
                </div>
            </div>
            <div class="row">
                <div class="col col-18">
                    <unit-intro-panel :height="346"></unit-intro-panel>
                </div>
                <div class="col col-6">
                    <query-service-panel :height="346"></query-service-panel>
                </div>
            </div>
            <div class="row">
                <div class="col col-12">
                    <guide-panel :height="272"></guide-panel>
                </div>
                <div class="col col-12">
                    <download-panel :height="272"></download-panel>
                </div>
            </div>
            <div class="row">
                <div class="col col-24">
                    <cert-panel :height="452"></cert-panel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NoticePanel from './components/notice-panel.vue';
import LoginPanel from './components/login-panel.vue';
import CenterServicePanel from './components/center-service-panel.vue';
import GuidePanel from './components/guide-panel.vue';
import DownloadPanel from './components/download-panel.vue';
import UnitIntroPanel from './components/unit-intro-panel.vue';
import QueryServicePanel from './components/query-service-panel.vue';
import CertPanel from './components/cert-panel.vue';

export default {
    components: {
        NoticePanel,
        LoginPanel,
        GuidePanel,
        DownloadPanel,
        UnitIntroPanel,
        QueryServicePanel,
        CenterServicePanel,
        CertPanel
    },

    data() {
        return {};
    },

    computed: {
        ...mapGetters(['isLogin'])
    }
};
</script>

<style lang="scss" scoped>
.home-page {
    width: 100%;
    background: #f7f8fb;

    .banner {
        width: 100%;
        aspect-ratio: 1920 / 260;
        background: url(../../assets/home/banner1.png) no-repeat;
        background-size: 100% 100%;
    }

    .content {
        width: 1200px;
        margin: 0 auto;
        transform: translateY(-24px);

        .row {
            margin-bottom: 16px;
            display: flex;

            .col {
                height: 100%;

                @for $i from 1 through 24 {
                    &.col-#{$i} {
                        width: calc((1200px - 16px) / 24 * #{$i});
                    }
                }

                &.col-24 {
                    width: 100%;
                }

                &:not(:last-child) {
                    margin-right: 16px;
                }
            }
        }
    }
}
</style>
